import React, { useEffect, useState } from "react";
import noImage from "../data/images/no-image1.jpeg";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const ImageCarousel = (props) => {
  const { roomUuid, images, customFunc, type } = props;
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide(slide === images.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? images.length - 1 : slide - 1);
  };

  let currentStyle;
  if (type === "rooms") {
    currentStyle =
      "h-60 w-80 object-cover border-gray-300 hover:border-snappily-orange border-2 cursor-pointer rounded-t-2xl";
  }
  if (type === "room") {
    currentStyle = "object-cover h-72 w-screen sm:h-[600px] cursor-pointer";
  }
  if (type === "bills") {
    currentStyle =
      "h-40 w-40 object-cover border-gray-300 hover:border-snappily-orange border-2 cursor-pointer  rounded-2xl";
  }

  return (
    <div className="flex justify-center items-center text-white">
      <div className="flex justify-center items-center relative">
        {images.length > 1 && (
          <BsArrowLeftCircleFill
            className="absolute h-10 w-10 left-3 text-white text-xl opacity-80 hover:cursor-pointer z-10"
            onClick={prevSlide}
          />
        )}
        {images.map((item, index) => {
          return (
            <Link to={`/rooms/${roomUuid}`} key={item}>
              <img
                className={`${currentStyle} ${slide === index ? "" : "hidden"}`}
                src={item instanceof Blob ? URL.createObjectURL(item) : item}
                alt={item.alt}
                onClick={() => {
                  customFunc
                    ? customFunc()
                    : item instanceof Blob
                    ? window.open(URL.createObjectURL(item))
                    : window.open(item);
                }}
              />
            </Link>
          );
        })}
        {images.length === 0 && (
          <Link to={`/rooms/${roomUuid}`}>
            <img
              src={noImage}
              alt="Not available"
              className={`${currentStyle}`}
              onClick={() => {
                customFunc ? customFunc() : window.open(noImage);
              }}
            />
          </Link>
        )}
        {images.length > 1 && (
          <BsArrowRightCircleFill
            className="absolute h-10 w-10 right-3 text-white text-xl opacity-80 hover:cursor-pointer z-10"
            onClick={nextSlide}
          />
        )}
        {images.length > 1 && (
          <span className="flex justify-center absolute bottom-3">
            {images.map((_, index) => {
              return (
                <button
                  className={`h-3 w-3 rounded-full border-white opacity-85 border-1 
                  outline-none mx-1 cursor-pointer backdrop-grayscale-0 backdrop-brightness-50 
                  ${slide === index ? "bg-snappily-orange" : "bg-none"} `}
                  key={index}
                  onClick={() => {
                    setSlide(index);
                  }}
                ></button>
              );
            })}
          </span>
        )}
      </div>
    </div>
  );
};

export default ImageCarousel;
